import { Scale } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { NON_RESERVED_FULL } from "@/lib/legal-notice";

/**
 * Single source of truth for the "legal advice on non-reserved matters"
 * statement. Rendered on the home page, resource centre, legal article
 * pages and anywhere else the scope of our advice needs to be explicit.
 */
export {
  NON_RESERVED_STATEMENT,
  NON_RESERVED_FULL,
  NON_RESERVED_ACKNOWLEDGEMENT,
} from "@/lib/legal-notice";

export function NonReservedNotice({
  tone = "light",
  className = "",
}: {
  tone?: "light" | "dark";
  className?: string;
}) {
  const dark = tone === "dark";
  return (
    <div
      className={`rounded-xl border p-4 text-sm leading-relaxed ${
        dark
          ? "border-gold/40 bg-navy-foreground/5 text-navy-foreground/90"
          : "border-gold/40 bg-gold/10 text-foreground"
      } ${className}`}
    >
      <p className="flex items-start gap-2">
        <Scale className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
        <span>
          <strong className={dark ? "text-navy-foreground" : "text-navy"}>
            We do provide legal advice — but only on non-reserved matters.
          </strong>{" "}
          {NON_RESERVED_FULL}{" "}
          <Link
            to="/compliance-services"
            className={`underline underline-offset-2 ${dark ? "hover:text-gold" : "hover:text-navy"}`}
          >
            See our full scope
          </Link>
          .
        </span>
      </p>
    </div>
  );
}
